import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findCostsPerEmployeeCatalogAct, loadCostsPerEmployeeCatalogByIdAct, saveCostsPerEmployeeCatalogAct, saveSuccessCostsPerEmployeeCatalogAct, 
    setViolationsCostsPerEmployeeCatalogAct, showMsgErrorAct, updateCostsPerEmployeeCatalogAct, updateSuccessCostsPerEmployeeCatalogAct } from "./cost-per-employee-catalog.action";
import { CostsPerEmployeeCatalogService } from "../../services/costs-per-employee-catalog.service";



@Injectable()
export class CostsPerEmployeeCatalogEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private costsPerEmployeeCatalogService = inject(CostsPerEmployeeCatalogService);
    private alerta = inject(AlertaService);

    findCostsPerEmployeeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCostsPerEmployeeCatalogAct),
            exhaustMap(action => this.costsPerEmployeeCatalogService.findCostsPerEmployeeCatalogById(action.id)
                .pipe(
                    map(costsPerEmployee => loadCostsPerEmployeeCatalogByIdAct({ costsPerEmployee })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/costsPerEmployeesCatalog']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveCostsPerEmployeeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveCostsPerEmployeeCatalogAct),
            exhaustMap(action => this.costsPerEmployeeCatalogService.createCostsPerEmployeeCatalog(action.costsPerEmployeeNew)
                .pipe(
                    map(costsPerEmployeeNew => saveSuccessCostsPerEmployeeCatalogAct({ costsPerEmployeeNew })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsCostsPerEmployeeCatalogAct({ costsPerEmployeeForm: action.costsPerEmployeeNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))*/
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsCostsPerEmployeeCatalogAct({ costsPerEmployeeForm: action.costsPerEmployeeNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    //)
                    )
                )
            )
        )
    );

    /*showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });*/
    showMsgErrorEffect$ = createEffect(() =>
            this.actions$.pipe(
              ofType(showMsgErrorAct),
              tap(action => {
                const detail = action.error?.error?.message || action.error?.message || null;
                //console.log('showMsgErrorEffect 111:');
                this.alerta.error(
                  'Se ha presentado un error interno Catalogo Beneficios',
                  detail ? { detail } : undefined
                );
                //console.log('showMsgErrorEffect 222:');
              })
            ),
            { dispatch: false }
          );

    saveSuccessCostsPerEmployeeCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessCostsPerEmployeeCatalogAct),
        tap(() => {
            this.router.navigate(['/costsPerEmployeesCatalog']);
            this.alerta.correct("Beneficio creado con exito!");
        })
    ), { dispatch: false });

    updateCostsPerEmployeeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateCostsPerEmployeeCatalogAct),
            exhaustMap(action => this.costsPerEmployeeCatalogService.updateCostsPerEmployeeCatalog(action.costsPerEmployeeUpdated)
                .pipe(
                    map(costsPerEmployeeUpdated => updateSuccessCostsPerEmployeeCatalogAct({ costsPerEmployeeUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsCostsPerEmployeeCatalogAct({ costsPerEmployeeForm: action.costsPerEmployeeUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessCostsPerEmployeeCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessCostsPerEmployeeCatalogAct),
        tap(() => {
            this.router.navigate(['/costsPerEmployeesCatalog']);
            this.alerta.correct("Beneficio editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}